const subsectionHeaderWithButtonStyle = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
};

export default subsectionHeaderWithButtonStyle;
